export const QuestionMarkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 11.25V10a1.667 1.667 0 1 0-1.666-1.667"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 3.625a6.375 6.375 0 1 1 0 12.75 6.375 6.375 0 0 1 0-12.75"
    ></path>
    <path
      fill="#23252A"
      d="M9.948 12.5a.65.65 0 1 0 .006 1.3.65.65 0 0 0-.006-1.3"
    ></path>
  </svg>
);
